export default __webpack_public_path__ + "static/montserrat-v15-latin-900-8211f418baeb8ec880b80ba3c682f957.woff";